import styled from "styled-components";

import { colors } from "../../../consts";
import { Paragraph2, WrapperContainer } from "../../../components";
import { TableWrapper } from "../../../components/Table/styled";

export const DeviceTableWrapper = styled(WrapperContainer)`
  ${TableWrapper} {
    overflow: visible;
  }
`;

export const DeviceImageContainer = styled(WrapperContainer)`
  width: 48px;
  height: 48px;

  border-radius: 8px;
  background: ${colors.ISABELLINE_DARKER};

  min-width: 48px;

  img {
    height: 75%;
  }
`;

export const CertificatesButtonText = styled(Paragraph2)`
  ${(props) => props?.disabled && `color: ${colors.RAISIN_50};`}
`;
